import * as React from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import { Redirect } from 'react-router'
import { noop } from '@pushly/aqe/lib/utils/noop'

@observer
export class Dashboard extends React.Component {
    public render() {
        return (
            <div className={classnames('page', 'dashboard')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader title="Dashboard" onTitleSet={noop} />

                    {/* REMOVE AFTER DASHBOARD BUILT */}
                    <Redirect from="/" to="/organizations" />
                </div>
            </div>
        )
    }
}
